import Bugsnag from "@bugsnag/js";
import { getQueryParams } from "@/utils/httpRequest";
import { borrowerService } from "@/modules/contacts/features/borrower/store/services/borrower-service";
import { BORROWER_SERVICE_TAG } from "@/modules/contacts/features/borrower/utils/borrower-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const getBorrowers = borrowerService.injectEndpoints({
  endpoints: builder => ({
    getBorrowers: builder.query({
      query: ({ params }) => `borrowers?${getQueryParams(params)}`,
      providesTags: result =>
        result
          ? [
              ...result.items.map(({ borrowerId }) => ({ type: BORROWER_SERVICE_TAG, borrowerId })),
              { type: BORROWER_SERVICE_TAG, id: LIST_SERVICE_TAG },
            ]
          : [{ type: BORROWER_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted({ params, setParams }, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (!data.items.length && params.page > 1) {
            setParams(prevParams => ({ ...prevParams, page: prevParams.page - 1 }));
          }
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetBorrowersQuery } = getBorrowers;

